import React, { useEffect, useMemo, useState } from "react";
import { Link } from "@quintype/components";
import { SvgIconHandler } from "../../../atoms/svg-icon-hadler";
import { getStoryHeadline } from "../../../utils/story";
import { shortenUrl } from "../../../../../api/utils";
import { useDeviceType } from "../../../custom-hooks/useDeviceType";

import "./sticky-bar.m.css";

function StickySocialShare({
  story,
  imageDimension,
  shareMenuOpen,
  setShareMenuOpen,
  isScrolled,
  iconSet,
  setCopyPopupOpen,
  onSocialIconClick,
  params = {},
}) {
  const { width, height, viewbox } = imageDimension;
  const [shortStoryUrl, setShortStoryUrl] = useState(story?.url);
  const icon = { width: width, height: height, viewBox: viewbox };

  const fetchShortUrl = async () => {
    try {
      const data = await shortenUrl(story?.url);
      setShortStoryUrl(data?.shortUrl);
    } catch (err) {
      console.error("Failed to shorten URL: ", err);
    }
  };
  useEffect(() => {
    !isScrolled && setShareMenuOpen(false);
    const closeShareMenu = () => setShareMenuOpen(false);
    document.body.addEventListener("click", closeShareMenu);

    return () => {
      document.body.removeEventListener("click", closeShareMenu);
    };
  }, [isScrolled]);

  useEffect(() => {
    const item = document.getElementById("copy-link");
    if (item !== null) {
      item.addEventListener("click", function () {
        setCopyPopupOpen(true);
        setTimeout(() => {
          setCopyPopupOpen(false);
        }, 3000);
      });
      fetchShortUrl();
    }
  }, [shareMenuOpen]);
  return (
    <span styleName="share">
      {iconSet?.map((item, index) => {
        return (
          <div key={index} onClick={() => onSocialIconClick(item?.label)}>
            <SvgIconHandler
              type={item?.id}
              height={icon.height}
              width={icon.width}
              viewBox={icon.viewBox}
              iconStyle={{ color: "#596E79" }}
            />
          </div>
        );
      })}
      <span
        styleName="copy-link-container"
        onClick={() => {
          setCopyPopupOpen(true);
          setTimeout(() => {
            setCopyPopupOpen(false);
          }, 3000);
          navigator.clipboard.writeText(story?.url);
        }}
      >
        <SvgIconHandler type="share-link" height={icon.height} width={icon.width} viewBox={icon.viewBox} />
      </span>

      <span
        id="share-menu-container"
        styleName="share-menu-container"
        onClick={() => setShareMenuOpen((prevVal) => !prevVal)}
      >
        <SvgIconHandler type="share-menu" height={icon.height} width={icon.width} viewBox={icon.viewBox} />
      </span>
    </span>
  );
}

export default function StickyBar({
  story,
  scrollRef,
  storyIndex,
  params = {},
  shareMenuOpen,
  setShareMenuOpen,
  iconSet,
  setCopyPopupOpen,
  shortStoryUrl,
  onSocialIconClick,
}) {
  const [isScrolled, setIsScrolled] = useState(false);
  const [progress, setProgress] = useState(0);
  const [currentStoryIndex, setCurrentStoryIndex] = useState(0);
  const [isNewStory, setIsNewStory] = useState(false);
  const deviceType = useDeviceType();

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = document.documentElement.scrollTop;
      if (storyIndex !== currentStoryIndex) {
        setCurrentStoryIndex(storyIndex);
        setProgress(0);
      }
      if (deviceType === "desktop") {
        if (scrollTop > 400 && !isScrolled) {
          setIsScrolled(true);
        }
        scrollTop < 380 && isScrolled && setIsScrolled(false);
      } else {
        if (scrollTop > 300 && !isScrolled) {
          setIsScrolled(true);
        }
        scrollTop < 260 && isScrolled && setIsScrolled(false);
        scrollTop < 260 && shareMenuOpen && setShareMenuOpen(false);
      }

      if (scrollRef.current && isScrolled) {
        const position = scrollRef.current.getBoundingClientRect();
        setIsNewStory(position.top > 0);
        setProgress((-position.top / position.height) * 100 + 10);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isScrolled, scrollRef.current, isNewStory]);

  return (
    <div styleName={`sticky-bar ${isScrolled ? "show" : ""}`}>
      <div styleName="sticky-content">
        <span styleName="sticky-headline">{story?.headline}</span>
        <span styleName="sticky-share-icons">
          <StickySocialShare
            story={story}
            imageDimension={{ width: "32px", height: "32px", viewbox: "0 0 32 32" }}
            shareMenuOpen={isScrolled ? shareMenuOpen : false}
            isScrolled={isScrolled}
            setShareMenuOpen={setShareMenuOpen}
            iconSet={iconSet}
            setCopyPopupOpen={setCopyPopupOpen}
            params={params}
            onSocialIconClick={onSocialIconClick}
          />
        </span>
      </div>
      <div styleName="progress-bar" style={{ width: `${progress}vw` }}></div>
    </div>
  );
}
